import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchComment,
  setCommentForEdit,
  selectLoading,
  updateComment,
  selectCommentForEditing,
} from "features/admin/Comments/commentsAdminSlice";
import AdminForm from "../AdminForm";

const EditComment = () => {
  const [progress, setProgress] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const comment = useSelector(selectCommentForEditing);
  const isLoading = useSelector(selectLoading);
  const navigate = useNavigate();
  useEffect(() => {
    !isLoading && dispatch(fetchComment(id));
    return () => {
      dispatch(setCommentForEdit(undefined));
    };
  }, [id]);
  
  const onSubmit = (obj: any) => {
    const data = { id: id, data: obj };
    dispatch(
      updateComment(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
      );
      navigate(-1);
    };
  console.log(comment);
  return (
    <AdminForm
      formTitle="Промяна на климатик"
      onSubmit={onSubmit}
      field={comment}
      progress={progress}
    />
  );
};

export default EditComment;
